import YYFileLogo from './file-logo'

export default YYFileLogo